export default "__VITE_ASSET__CFKcnwUb__"